module.exports = __webpack_public_path__ + "static/media/efficiency-bro-business.ae807326.svg";